import { render } from "./VerticalOneSided.vue?vue&type=template&id=2660ab12"
import script from "./VerticalOneSided.vue?vue&type=script&lang=js"
export * from "./VerticalOneSided.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__